import React, { useState } from 'react';
import './Footer.css';
import { FaRegBell, FaHome, FaRegChartBar } from 'react-icons/fa';
import { MdReceipt, MdOutlineAdd } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState('/');

  const handleNavigation = (path) => {
    setActive(path);
    navigate(path);
  };

  return (
    <footer className="footer">
      <button
        className={`footer-icon ${active === '/reminder' ? 'active' : ''}`}
        onClick={() => handleNavigation('/reminder')}
      >
        <FaRegBell />
        <span style={{color: active === '/reminder' ? 'white' : '' }}>Reminders</span>
      </button>
      <button
        className={`footer-icon ${active === '/receipt' ? 'active' : ''}`}
        onClick={() => handleNavigation('/receipt')}
      >
        <MdReceipt />
        <span style={{color: active === '/receipt' ? 'white' : '' }}>Receipt</span>
      </button>
      <button
        className={`footer-icon add-icon ${active === '/add-expense' ? 'active' : ''}`}
        onClick={() => handleNavigation('/add-expense')}
      >
        <MdOutlineAdd size={50} />
      </button>
      <button
        className={`footer-icon ${active === '/statistics' ? 'active' : ''}`}
        onClick={() => handleNavigation('/statistics')}
      >
        <FaRegChartBar />
        <span style={{color: active === '/statistics' ? 'white' : '' }}>Statistics</span>
      </button>
      <button
        className={`footer-icon ${active === '/' ? 'active' : ''}`}
        onClick={() => handleNavigation('/')}
      >
        <FaHome />
        <span style={{color: active === '/' ? 'white' : '' }}>Home</span>
      </button>
    </footer>
  );
};

export default Footer;
